/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const teamMembershipRequestSchema = z.object({
  commitment: z.number().min(0).max(1).nullish(),
  endDate: z.iso.date().nullish(),
  roleId: z.int().nullish(),
  startDate: z.iso.date().nullish(),
  teamId: z.int(),
});
